import React, { useContext } from 'react'
import { FarmerContext } from './FarmerProviderComp'
import { ThemeContext } from 'styled-components'
import { Icon, Label } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { StyledFilterWrapper } from './style'
import { getFarmersFilters } from '~/Constants'
import { FarmersOptionsType } from '~/api/services/farmers/index'

interface FilterValuesProps {
  dataFiltered: any
  handleChangeDataFiltered: (data: any) => void
  farmersListOptions: FarmersOptionsType
}
const dropdownFilterKeys = ['search', 'farmerGroupId', 'lastDeliveryDate', 'terminationDate']
const FilterValues: React.FC<FilterValuesProps> = (props) => {
  const { t } = useTranslation()
  const { dataFiltered, handleChangeDataFiltered, farmersListOptions } = props
  const { firstColor } = useContext(ThemeContext)
  const {
    contextValues,
    contextValues: {
      filterInputValues,
      checkedFilters,
      search
    },
    setContextValues
  } = useContext(FarmerContext)

  function renderFilterValues() {
    return Object.keys(filterInputValues).map(filterInputKey => {
      const filter = checkedFilters.find(checkedFilter => checkedFilter.key === filterInputKey)
      return dataFiltered[filterInputKey] !== '' && <Label style={{ background: firstColor, color: 'white' }} as='a'>
        {`${t(filter?.placeholder)} (${Number(dataFiltered[filterInputKey]).toLocaleString('de', { minimumFractionDigits: 0 })})`}
        <Icon name='delete' onClick={() => {
          setContextValues({
            ...contextValues,
            filterInputValues: {
              ...contextValues.filterInputValues,
              [filterInputKey]: ''
            }
          })
        }} />
      </Label>
    })
  }

  function getFarmerGroupLabelText(key) {
    const filterOption = farmersListOptions?.farmerGroups.find(farmerGroupOption => farmerGroupOption.id === dataFiltered[key])
    const textValue = filterOption?.name
    return t('Farmer group ({{textValue}})', { textValue })
  }

  function getDefaultFarmerLabelText(key) {
    const farmersFilters = getFarmersFilters()
    const filter = farmersFilters.find(farmersFilter => farmersFilter.key === key)
    const textValue = filter?.options?.find(option => option.value === dataFiltered[key])
    return `${filter?.placeholder} (${textValue.text})`
  }

  function getNameFilter(key) {
    switch (key) {
      case 'search':
        return t('Search ({{search}})', { search })
      case 'farmerGroupId':
        return getFarmerGroupLabelText(key)
      default:
        return getDefaultFarmerLabelText(key)
    }
  }

  function renderDropdownFilterValues() {
    return dropdownFilterKeys.map(dropdownFilterKey => {
      return dataFiltered[dropdownFilterKey] !== '' && <Label style={{ background: firstColor, color: 'white' }} as='a'>
        {getNameFilter(dropdownFilterKey)}
        <Icon name='delete' onClick={() => {
          if (dropdownFilterKey === 'search') {
            setContextValues({
              ...contextValues,
              search: ''
            })
          } else {
            handleChangeDataFiltered({
              ...dataFiltered,
              [dropdownFilterKey]: ''
            })
          }
        }} />
      </Label>
    })
  }

  return <StyledFilterWrapper>
    {renderDropdownFilterValues()}
    {renderFilterValues()}
  </StyledFilterWrapper>
}
export default FilterValues